import {
  Component,
  OnInit,
  OnDestroy,
  ElementRef,
  Inject,
  ViewChild,
  Directive,
  HostListener,
  AfterViewInit
} from '@angular/core';
import { firstValueFrom, Subscription, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';

import { DirectionService } from '../../direction.service';
import { DialogService } from 'src/app/dialog/dialog.service';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

import { NgForm, FormControl, FormGroup, Validators, AbstractControl, FormBuilder } from "@angular/forms";
import { CreditFormService } from 'src/app/other-pages/my-profile/credit-form-service';

import { Direction } from '@angular/cdk/bidi';
import { MatTooltip } from '@angular/material/tooltip';
import { getLocaleId } from '@angular/common';
import { DateAdapter } from '@angular/material/core';

import { Router } from "@angular/router";
import { UsersService } from 'src/app/super-management/user/users.service';

import lottie from 'lottie-web';
import { AuthService } from 'src/app/auth/auth.service';
import { set } from 'lodash';

import { OrdersService } from "../../main-section/printing-table/order.service";
import * as http from "node:http";
import { TranslateService } from '@ngx-translate/core';
import { DataSharingService } from 'src/app/main-section/data-shering-service/data-sharing.service';
import { MatSnackBar } from '@angular/material/snack-bar';

@Directive({
  selector: '[appPhoneFormatOrderSummery]'
})

export class PhoneFormatOrderSummeryDirective {
  constructor(private el: ElementRef) {
  }

  @HostListener('input', ['$event']) onInputChange(event) {
    const initialValue = this.el.nativeElement.value;

    this.el.nativeElement.value = initialValue.replace(/[^0-9]/g, '')
      .replace(/(\d{2})(\d{4})(\d{3})/, '0$1-$2-$3');

    if (initialValue !== this.el.nativeElement.value) {
      event.stopPropagation();
    }
  }
}

@Component({
  selector: 'app-order-summary',
  templateUrl: './order-summary.component.html',
  styleUrls: ['./order-summary.component.css'],
  host: {
    class: 'fill-screen-modal-order-summary'
  }
})
export class OrderSummaryComponent implements OnInit, OnDestroy {
  isRTL: boolean = true;
  private directionSubscription: Subscription;
  isDarkMode: boolean = false;

  isLoading: boolean = false;
  isLoadingText: string = '';
  isLoadingSendToPrint: boolean = false;

  printingService: string;
  branchPapers: string;
  files: any;
  branchName: string;
  printerID: string;
  orderID: string;
  totalPriceData: any;
  user: any;
  isPendingOrder: boolean = false;
  isAdminOrder: boolean = false;
  branchUnique: number = 0;
  printingCode: number = 0;
  userPrintingCode: string = null;
  isPicsPrinter: boolean = false;
  picsDiscount: number = null;

  isCreditCardFieldsEmphasized: boolean = false;

  fixProducts: any;
  fixProductsArray: any = [];
  fixProductsOrderId: string = null;
  expressAttachedOrderId: string = null;

  isFixedProductsNeedsToBePayed: boolean = false;
  isFixedProductsAproved: boolean = false;
  isFixedProductsPayed: boolean = false;
  isFixedProductsPicked: boolean = false;

  isOrderAproved: boolean = false;
  isCreditMode: boolean = false;
  isLoadingUpdates = false;

  isOrderPrinted: boolean = false;
  isOrderSaved: boolean = false;

  creditForm = this.creditFormService.createForm(null);
  isCompanyID: boolean = false;

  tooltipDirection: Direction = 'ltr';
  @ViewChild(MatTooltip) tooltip: MatTooltip;

  @ViewChild('monthInput') monthInput;
  @ViewChild('yearInput') yearInput;

  phoneForm: FormGroup;
  animation: any;
  confettiAnimation: any;

  isLottieStart: boolean = false;
  isLottieMiddle: boolean = false;
  isLottieEnd: boolean = false;

  isLogedIn: boolean = false;

  @ViewChild('expressInput') expressInput: ElementRef;

  isAfterOptionBtnAnimated: boolean = false;
  serverAddress: string;

  userId: string;
  userIsAuthenticated = false;
  private authStatusSub: Subscription;

  constructor(
    private directionService: DirectionService,
    private dialogService: DialogService,
    private elRef: ElementRef,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private creditFormService: CreditFormService,
    private dateAdapter: DateAdapter<Date>,
    private router: Router,
    private usersService: UsersService,
    private authService: AuthService,
    private OrdersService: OrdersService,
    private fb: FormBuilder,
    private httpClient: HttpClient,
    private translate: TranslateService,
    private dataSharingService: DataSharingService,
    private snackBar: MatSnackBar,
  ) {
    this.printingService = data.printingService;
    this.serverAddress = data.serverAddress;
    this.branchPapers = data.branchPapers;
    this.files = data.files;
    // console.log("this.files", this.files);
    this.branchName = data.branchName;
    this.printerID = data.printerID;
    this.orderID = data.orderID;
    this.totalPriceData = data.totalPriceData;
    if (!this.totalPriceData?.fixProductsTotalPrice) {
      this.totalPriceData.fixProductsTotalPrice = 0;
    }
    this.user = data.user;
    this.isPendingOrder = data.isPendingOrder;
    this.isAdminOrder = data.isAdminOrder;
    this.branchUnique = data.branchUnique;
    this.creditForm = this.fb.group({
      month: ['', [Validators.required, Validators.pattern('^(0[1-9]|1[0-2])$')]],
      year: ['', [Validators.required, Validators.pattern('^[0-9]{2}$')]]
    });
    this.printingCode = data.printingCode;
    this.fixProducts = data.fixProducts;
    this.isPicsPrinter = data.isPicsPrinter ? data.isPicsPrinter : false;
    this.picsDiscount = data.picsDiscount ? data.picsDiscount : null;
  }

  async ngOnInit() {
    this.isLoading = true;
    if (!this.printingService || !this.serverAddress || !this.branchPapers || (!this.files && !this.fixProducts) || !this.branchName || !this.totalPriceData || !this.user) {
      if (localStorage.getItem('printingService') && localStorage.getItem('branch')) {
        this.router.navigate(['/qr/' + localStorage.getItem('printingService') + '/' + localStorage.getItem('branch')]);
      }
      this.closeOrderSummaryDialog();
    }

    try {
      this.directionSubscription = this.directionService.direction$.subscribe(direction => {
        this.isRTL = direction === 'rtl';
        this.tooltipDirection = this.isRTL ? 'rtl' : 'ltr';
      });

      this.directionService.isDarkMode$.subscribe(isDarkMode => {
        this.isDarkMode = isDarkMode;
      });

      if (this.fixProducts && this.fixProducts.products && this.fixProducts.products.length > 0) {
        this.isFixedProductsNeedsToBePayed = true;
        for (let i = 0; i < this.fixProducts.products.length; i++) {
          if (this.fixProducts.products[i].numOfCopies > 0) {
            this.fixProductsArray.push(this.fixProducts.products[i]);
          }
        }
        // console.log("this.fixProductsArray", this.fixProductsArray);
      }

      this.userIsAuthenticated = this.authService.getIsAuth();
      this.authStatusSub = this.authService
        .getAuthStatusListener()
        .subscribe(isAuthenticated => {
          this.userIsAuthenticated = isAuthenticated;
          this.userId = this.authService.getUserId();
          if (this.userIsAuthenticated) {
            localStorage.setItem('dontOpenRP', 'true');
          }
        });

      if (this.userIsAuthenticated) {
        // ---------- user is logedin
        this.isLogedIn = true;
        if (this.user) {
          // Credit Form
          this.creditForm = this.creditFormService.createForm(this.user);
          if (this.user.zCreditInfo && this.user.zCreditInfo.customerID) {
            this.isCompanyID = true;
          }
        } else {
          // Credit Form
          this.creditForm = this.creditFormService.createForm(null);
        }
        this.phoneForm = new FormGroup({
          phone: new FormControl(null, {
            validators: [Validators.required, this.phoneValidator]
          })
        });
        // // ---------- user is logedin
      } else {
        // ---------- user is not logedin
        this.isLogedIn = false;
        if (!localStorage.getItem('userId')) {
          this.authService.logout();
        }
        // // ---------- user is not logedin
      }
      this.isLoading = false;
    } catch (error) {
      console.error("error", error);
      if (localStorage.getItem('printingService') && localStorage.getItem('branch')) {
        this.router.navigate(['/qr/' + localStorage.getItem('printingService') + '/' + localStorage.getItem('branch')]);
      } else {
        this.router.navigate(['/']);
      }
    }
  }

  closeOrderSummaryDialog() {
    this.dialogService.onCloseOrderSummaryDialog();
  }

  aproveOrderSummary() {
    this.isAfterOptionBtnAnimated = false;
    this.playAnimation();
    setTimeout(() => {
      this.isOrderAproved = true;
      if (this.printingService === 'plotter' && this.isPendingOrder) {
        this.onSendOrderToPrint();
      }
      if ((!this.user.zCreditInfo?.token || this.user.zCreditInfo.token === '') &&
        !(this.user.discount && this.user.discount === 100) &&
        !this.isAdminOrder) {
        this.isCreditMode = true;
        this.isCreditCardFieldsEmphasized = false;
        return;
      }
    }, 1900);
  }

  disaproveOrderSummary() {
    this.isOrderAproved = false;
    this.isLottieStart = false;
    this.isLottieEnd = false;
    this.isLottieStart = false;
    if (this.animation) {
      this.animation.stop();
    }
  }

  getCCLastDigits(cc: string): string {
    if (!cc) {
      return '';
    }
    const ccStr = cc.toString();
    if (ccStr.length >= 4) {
      return ccStr;
    } else {
      return ccStr.padStart(4, '0');
    }
  }

  editCCOrderSummary() {
    const ordersUserId = this.user._id.toString()
    if (this.isLogedIn && this.userIsAuthenticated &&
      localStorage.getItem('userId') && localStorage.getItem('userId') !== '' &&
      ordersUserId && ordersUserId !== '' && localStorage.getItem('userId') === ordersUserId) {
      this.isCreditMode = true;
      this.isCreditCardFieldsEmphasized = false;
    } else {
      if (!localStorage.getItem('userId') || localStorage.getItem('userId') === '' ||
        !ordersUserId || ordersUserId === '' || localStorage.getItem('userId') !== ordersUserId) {
        this.authService.logout(false);
      }
      this.dialogService.onOpenLoginDialog();
    }
  }

  backToOrderCCOrderSummary() {
    this.isCreditMode = false;
  }

  // [general]
  roundDownTowDecimal(num: number): number {
    return Math.round(num * 100) / 100;
  }

  getSizePlotter(size: number) {
    return Math.round((size / 300 * 2.54) * 100) / 100;
  }

  ngOnDestroy() {
    if (this.directionSubscription) {
      this.directionSubscription.unsubscribe();
    }
  }

  async onSaveOrderForAfter() {
    // console.log("onSaveOrderForAfter");
    if ((this.user.zCreditInfo?.token && this.user.zCreditInfo.token !== '') || this.user.roles.includes('su') || this.isAdminOrder || this.user.discount === 100) {

      // create array of file ids
      const filesIds = this.files.map(file => file.fileId);
      // create order
      this.isLoading = true;
      // [plotter]
      if (this.printingService === 'plotter') {
        const branchTranslatedName = this.translate.instant('choose-branch.naming.plotter.' + this.branchName);
        this.OrdersService.createPlotterOrder(
          filesIds,
          this.printerID,
          branchTranslatedName,
          false,
        ).subscribe((response: any) => {
          if (response.message === 'Order created successfully') {
            setTimeout(() => {
              this.playAnimation();
              setTimeout(() => {
                this.isLoading = false;
                this.isOrderSaved = true;
                this.playConfettiAnimation();
              }, 1900);
            }, 1000);
            if (response.order && response.order._id) {
              this.orderID = response.order._id;
            }
          }
        }, error => {
          console.log("error", error);
          this.isLoading = false;
        });
        // [express]
      } else if (this.printingService === 'express') {
        const branchTranslatedName = this.translate.instant('choose-branch.naming.express.' + this.branchName);
        this.OrdersService.createExpressOrder(
          filesIds,
          this.printerID,
          null,
          branchTranslatedName,
          false,
          null,
          null,
          this.picsDiscount,
        ).subscribe((response: any) => {
          if (response.message === 'Order created successfully') {
            setTimeout(() => {
              this.playAnimation();
              setTimeout(() => {
                this.isLoading = false;
                this.isOrderSaved = true;
                this.playConfettiAnimation();
              }, 1900);
            }, 1000);
            if (response.order && response.order._id) {
              this.orderID = response.order._id;
            }
          }
        }, error => {
          console.log("error", error);
          this.isLoading = false;
        });
      }
    } else {
      this.isCreditMode = true;
      this.isCreditCardFieldsEmphasized = false;
    }
  }

  async payFixProducts() {
    // console.log("payFixProducts", this.fixProductsArray);
    this.isFixedProductsAproved = true;
    this.isLoading = true;
    // [express] - fix products
    if (this.printingService === 'express' && this.fixProductsArray && this.fixProductsArray.length > 0 && this.isFixedProductsNeedsToBePayed) {
      try {
        const branchTranslatedName = this.translate.instant('choose-branch.naming.plotter.' + this.branchName);
        // const isOrderHasOnlyFixProducts = !(this.files && this.files.length > 0);
        // console.log("isOrderHasOnlyFixProducts", isOrderHasOnlyFixProducts);
        const response: any = await firstValueFrom(this.OrdersService.createFixProductsOrder(
          this.fixProductsArray,
          this.printerID,
          branchTranslatedName,
        ));
        if (response.message === 'Fix products order created successfully') {
          // console.log("Fix products order created successfully");
          this.isFixedProductsNeedsToBePayed = false;
          this.isFixedProductsPayed = true;
          this.fixProductsOrderId = response.fixProductsOrderId;
          this.expressAttachedOrderId = response.expressAttachedOrderId;
        } else {
          this.isFixedProductsAproved = false;
        }
        this.isLoading = false;
        this.isLoadingText = '';
      } catch (error) {
        console.error("Error creating fix products order:", error);
        this.isFixedProductsAproved = false;
        this.isLoading = false;
        this.isLoadingText = '';
      }
    } else {
      this.isFixedProductsAproved = false;
      this.isLoading = false;
    }
  }

  onPickedFixProducts() {
    this.isFixedProductsPicked = true;
    this.dataSharingService.notifyFixProductsOrderCreated();
    if (this.files && this.files.length > 0) {
      this.onSendOrderToPrint(this.userPrintingCode);
    } else {
      this.openRightPlaceDialog();
    }
  }

  // [plotter]
  getImgPlotter(img) {
    let newThumbnail = '';
    if (this.isPendingOrder) {
      if (img.path.startsWith("uploads")) {
        newThumbnail = this.serverAddress + "/" + img.path;
      } else {
        const shortThumbnail = img.path.replace('/home/ubuntu/IMG-Plotter', '');
        newThumbnail = this.serverAddress + shortThumbnail;
      }
    } else {
      newThumbnail = img.path;
    }
    return newThumbnail;
  }

  async onSendOrderToPrint(printingCode: string = null) {
    if (this.isFixedProductsNeedsToBePayed && !this.isFixedProductsPayed) {
      if (printingCode && printingCode !== null && parseInt(printingCode)) {
        this.userPrintingCode = printingCode;
        this.payFixProducts();
      }
      return;
    }
    if ((this.user.zCreditInfo?.token && this.user.zCreditInfo.token !== '') || this.user.roles.includes('su') || this.isAdminOrder || this.user.discount === 100) {
      this.isLoading = true;

      this.isLoadingText = 'prepering-files';
      setTimeout(() => {
        if (this.isLoadingText !== '') {
          this.isLoadingText = 'prepering-order';
          setTimeout(() => {
            if (this.isLoadingText !== '') {
              this.isLoadingText = 'sending-order';
            }
          }, 6000);
        }
      }, 6000);

      if (!this.orderID && this.files && this.files.length > 0 && !this.isPendingOrder) {
        // console.log("creating order");
        const filesIds = this.files.map(file => file.fileId);
        // [plotter]
        if (this.printingService === 'plotter') {
          try {
            const branchTranslatedName = this.translate.instant('choose-branch.naming.plotter.' + this.branchName);
            const response = await firstValueFrom(this.OrdersService.createPlotterOrder(
              filesIds,
              this.printerID,
              branchTranslatedName,
              true,
            ));
            // console.log('Success:', response);
            this.orderID = response.order._id;
          } catch (error) {
            console.error("Error creating order:", error);
            this.isLoading = false;
            this.isLoadingText = '';
            return; // Stop execution if order creation fails
          }
          // [express]
        } else if (this.printingService === 'express') {
          try {
            const response: any = await firstValueFrom(this.OrdersService.createExpressOrder(
              filesIds,
              this.printerID,
              printingCode,
              null,
              true,
              this.fixProductsOrderId,
              this.expressAttachedOrderId,
              this.picsDiscount,
            ));
            if (response.message === 'Order created successfully') {
              // console.log("order created successfully");
              this.orderID = response.order._id;
            }
          } catch (error) {
            console.error("Error creating order:", error);
            this.isLoading = false;
            this.isLoadingText = '';
            this.isFixedProductsAproved = false;
            this.isFixedProductsPayed = false;
            return; // Stop execution if order creation fails
          }
        }
      }

      this.isLoading = true;
      this.isLoadingSendToPrint = true;

      // [plotter]
      if (this.printingService === 'plotter') {
        this.httpClient.post(this.serverAddress + '/api/orders/print', {
          orderID: this.orderID,
        }).subscribe({
          next: (response) => {
            // Success handling
            // console.log('Success:', response);
            this.playSentToPrintAnimation();
          },
          error: (error) => {
            // Failure handling
            console.error('Error:', error);
            if (error.error.message === 'PAYMENT_ERROR') {
              this.isCreditMode = true;
              this.isCreditCardFieldsEmphasized = false;
            } else if (error.error.message === 'ORDER_ALREADY_IN_QUEUE') {
              this.playSentToPrintAnimation();
            }
            this.isLoading = false;
            this.isLoadingText = '';
          }
        });

        // [express]
      } else if (this.printingService === 'express') {
        this.httpClient.post(this.serverAddress + '/api/orders/print', {
          code: printingCode,
          orderID: this.orderID,
        }).subscribe({
          next: (response) => {
            // Success handling
            // console.log('Success:', response);
            this.playSentToPrintAnimation();
          },
          error: (error) => {
            // Failure handling
            // console.error('Error:', error);
            if (error.error.message === 'PAYMENT_ERROR') {
              this.isCreditMode = true;
              this.isCreditCardFieldsEmphasized = false;
            } else if (error.error.message === 'ORDER_ALREADY_IN_QUEUE') {
              this.playSentToPrintAnimation();
            } else {
              this.isFixedProductsAproved = false;
              this.isFixedProductsPayed = false;
            }
            this.isLoading = false;
            this.isLoadingText = '';
          }
        });
      } else {
        this.playSentToPrintAnimation();
      }
      // if no resposne from server after 10 seconds
      setTimeout(() => {
        this.onCheckOrdersStatus();
      }, 10000);

    } else {
      this.isLoadingText = '';
      this.isLoading = false;
      this.isCreditMode = true;
      this.isCreditCardFieldsEmphasized = false;
    }
  }

  onCheckOrdersStatus(attempt: number = 1) {
    // console.log("onCheckOrdersStatus attempt:", attempt);
    if (this.isLoadingSendToPrint && this.printingService && this.orderID) {
      this.OrdersService.checkOrderStatus(
        this.printingService,
        this.orderID,
      ).subscribe(
        (response: any) => {
          if (this.isLoadingSendToPrint) {
            if (response.status && response.status === 'INQUEUE') {
              this.isLoadingSendToPrint = false;
              this.playSentToPrintAnimation();
            } else if (attempt < 10) {
              setTimeout(() => this.onCheckOrdersStatus(attempt + 1), 2000);
            } else {
              this.isLoadingSendToPrint = false;
              this.isLoadingText = '';
              this.isOrderPrinted = false;
            }
          }
        },
        error => {
          if (this.isLoadingSendToPrint) {
            if (attempt < 10) {
              setTimeout(() => this.onCheckOrdersStatus(attempt + 1), 2000);
            } else {
              this.isLoadingSendToPrint = false;
              this.isLoadingText = '';
              this.isOrderPrinted = false;
            }
          }
        }
      );
    }
  }

  onSaveCreditCard() {
    if (this.creditForm.get('cardNum').invalid
      || this.creditForm.get('month').invalid
      || this.creditForm.get('year').invalid
      || this.creditForm.get('cardCvv').invalid
      || this.creditForm.get('cardHolderName').invalid
      || this.creditForm.get('cardHolderID').invalid) {
      return;
    }
    let cc = {
      exp_m: this.creditForm.value.month,
      exp_y: this.creditForm.value.year,
      num: this.creditForm.value.cardNum.replace(/-/g, ''),
      cvv: this.creditForm.value.cardCvv,
      id: this.creditForm.value.cardHolderID,
      name: this.creditForm.value.cardHolderName,
      customerName: (this.creditForm.value.cardCustomerName && this.creditForm.value.cardCustomerName !== '') ? this.creditForm.value.cardCustomerName : this.user.username,
      customerEmail: (this.creditForm.value.billingEmail && this.creditForm.value.billingEmail !== '') ? this.creditForm.value.billingEmail : this.user.email,
      customerBusinessID: (this.isCompanyID && this.creditForm.value.cardCompanyID && this.creditForm.value.cardCompanyID !== '') ? this.creditForm.value.cardCompanyID : null
    }
    // console.log("cc", cc);
    this.usersService.updateUserCC(
      localStorage.getItem('userId'),
      cc,
    ).subscribe((response: any) => {
      if (response.user?.zCreditInfo?.token &&
        response.user.zCreditInfo.token !== '' &&
        response.user?.zCreditInfo?.cardNum &&
        response.user.zCreditInfo.cardNum !== '' &&
        response.user?.zCreditInfo?.cardExp &&
        response.user.zCreditInfo.cardExp !== '' &&
        response.user?.zCreditInfo?.cvv &&
        response.user.zCreditInfo.cvv !== ''
      ) {
        this.scrollToTop();
        setTimeout(() => {
          this.playAnimation();
          setTimeout(() => {
            this.isCreditMode = false;
            this.user.zCreditInfo = response.user.zCreditInfo;
            this.creditForm = this.creditFormService.createForm(this.user);
            this.isLoading = false;
          }, 1600);
        }, 100);
      }
    });
  }

  emphasizeCreditCardFields() {
    if (this.creditForm.get('cardNum').valid &&
      this.creditForm.get('month').valid &&
      this.creditForm.get('year').valid &&
      this.creditForm.get('cardCvv').valid &&
      this.creditForm.get('cardHolderName').valid &&
      this.creditForm.get('cardHolderID').valid) {
      this.isCreditCardFieldsEmphasized = false;
      return;
    }
    this.isCreditCardFieldsEmphasized = true;
  }

  playSentToPrintAnimation() {
    this.isLoadingSendToPrint = false;
    this.isLoadingText = '';
    setTimeout(() => {
      this.playAnimation();
      setTimeout(() => {
        this.isLoading = false;
        this.isOrderPrinted = true;
        this.playConfettiAnimation();
      }, 1900);
    }, 1000);
  }

  onDeleteCreditCard() {
    this.usersService.deleteUserCC(
      localStorage.getItem('userId'),
      this.user.zCreditInfo,
    ).subscribe((response: any) => {
      if (response.message === 'Credit card information deleted successfully') {
        this.user.zCreditInfo = null;
        this.creditForm = this.creditFormService.createForm(this.user);
        this.scrollToTop();
        setTimeout(() => {
          this.playAnimation();
          setTimeout(() => {
            this.isLoading = false;
          }, 1600);
        }, 100);
      }
    });
  }

  // Card Number
  numberOnly(event: KeyboardEvent): boolean {
    const charCode = (event.which) ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      event.preventDefault();
      return false;
    }
    return true;
  }

  formatCardNumInput(event): void {
    let input = event.target.value.replace(/\D/g, '');
    if (input.length > 16) {
      input = input.slice(0, 16);
    }
    input = input.replace(/(.{4})/g, '$1-');
    if (input.endsWith('-')) {
      input = input.slice(0, -1);
    }
    this.creditForm.get('cardNum').setValue(input, { emitEvent: false });
  }

  focusMonthIfEmpty() {
    if (!this.creditForm.get('month').value || this.creditForm.get('month').value === '') {
      this.creditForm.get('month').setValue(null);
      this.monthInput.nativeElement.focus();
    }
  }

  creditCardValidator(control: FormControl): { [s: string]: boolean } | null {
    if (!control.value) {
      return null;
    }
    const pattern = /^\d{4}-\d{4}-\d{4}-\d{4}$/;
    if (!control.value.match(pattern)) {
      return { 'invalidCreditCard': true };
    }
    return null;
  }

  clearCreditField(field: string) {
    // console.log('clearCreaditFields = field', field);
    this.creditForm.get(field).setValue(this.user[field]);
  }

  toggleTooltip() {
    if (this.tooltip._isTooltipVisible()) {
      this.tooltip.hide();
    } else {
      this.tooltip.show();
    }
  }

  toggleCompanyID() {
    this.isCompanyID = !this.isCompanyID;
    // find a div with the id of
  }

  openWhatsApp() {
    const phoneNumber = '97233746962';
    const message = encodeURIComponent('After-Sending-To-Print');
    const url = `https://wa.me/${phoneNumber}?text=${message}`;
    window.open(url, '_blank');
  }

  openRightPlaceDialog() {
    if (this.isLogedIn) {
      this.dialogService.onOpenRightPlaceDialog();
    } else {
      this.dialogService.onOpenLoginDialog();
    }
    this.closeOrderSummaryDialog();
  }

  goToMyOrders() {
    this.router.navigate([`/myorders/${localStorage.getItem('userId')}`]);
    this.closeOrderSummaryDialog();
  }

  goToPrintingQueue() {
    this.router.navigate(['/queue/' + this.branchUnique]);
    this.closeOrderSummaryDialog();
  }

  // PHONE
  // format phone
  formatPhoneNumber(phoneNumber: number): string {
    if (!phoneNumber) {
      return '';
    }
    const str = '0' + phoneNumber.toString();
    return str.slice(0, 3) + '-' + str.slice(3, 7) + '-' + str.slice(7);
  }

  // validate phone
  phoneValidator(control: AbstractControl): { [key: string]: any } | null {
    const valid = control.value && typeof control.value === 'string' && control.value.replace(/\D/g, '').length === 10;
    return valid ? null : { invalidPhone: { valid: false, value: control.value } };
  }

  // compere phone
  comperePhoneNumbers(usersPhone: any, editedPhone: any) {
    if (typeof editedPhone !== 'string' || !usersPhone || !editedPhone) {
      return true;
    }
    const normalizedUsersPhone = usersPhone.toString();
    const normalizedEditedPhone = editedPhone.replace(/-/g, '').replace(/^0+/, '');
    if (normalizedUsersPhone === normalizedEditedPhone) {
      return false;
    }
    return true;
  }

  clearPhoneField() {
    this.phoneForm.patchValue({
      phone: ''
    });
  }

  // save user profile fields
  onSaveUserPhone() {
    if (this.phoneForm.invalid) {
      return;
    }
    this.isLoading = true;
    this.usersService.updateUserPhone(
      localStorage.getItem('userId'),
      this.phoneForm.value.phone,
    ).subscribe((response: any) => {
      if (response.message === 'Update User Phone successful!') {
        this.user.phone = response.user.phone;
        this.phoneForm.patchValue({
          phone: this.formatPhoneNumber(this.user.phone)
        });
        this.usersService.updatePhone(this.user.phone);
        this.isLoading = false;
      }
    });
  }

  // LOTTIE ANIMATION
  ngAfterViewInit() {
    this.animation = lottie.loadAnimation({
      container: document.getElementById('animationContainer'),
      renderer: 'svg',
      loop: false,
      autoplay: false,
      path: 'assets/videos/successfully.json'
    });

    this.animation.setSpeed(2.6);
  }

  playAnimation() {
    if (this.animation) {
      this.animation.play();
    }
    this.isLottieStart = false;
    this.isLottieEnd = false;
    this.isLottieMiddle = false;
    setTimeout(() => {
      this.isLottieStart = true;
      setTimeout(() => {
        this.isLottieMiddle = true;
        setTimeout(() => {
          this.isLottieEnd = true;
          this.animation.stop();
          this.isLottieStart = false;
          this.isLottieMiddle = false;
        }, 400);
      }, 1500);
    }, 0);
  }

  playConfettiAnimation() {
    // console.log("playConfettiAnimation");
    setTimeout(() => {
      this.confettiAnimation = lottie.loadAnimation({
        container: document.getElementById('animationConfettiContainer'),
        renderer: 'svg',
        loop: false,
        autoplay: true,
        path: 'assets/videos/confetti.json'
      });
    }, 5);
  }

  scrollToTop() {
    const dialogElement = document.querySelector('.mat-mdc-dialog-surface');
    if (dialogElement) {
      dialogElement.scrollTo({ top: 0, behavior: 'smooth' });
    }
  }

  focusInput() {
    this.isAfterOptionBtnAnimated = false;
    if (this.printingService === 'express') {
      this.expressInput.nativeElement.focus();
    }
  }

  animateAfterOptionBtn() {
    if (!this.isAfterOptionBtnAnimated) {
      this.isAfterOptionBtnAnimated = true;
      setTimeout(() => {
        this.isAfterOptionBtnAnimated = false;
      }, 5000);
    }
  }

  getPrintingService(service: string) {
    if (service === 'plotter') {
      return "plotter";
    } else {
      if (this.isPicsPrinter) {
        return "pics";
      } else
        return "express";
    }
  }

  getAmountOfFixProducts(products: any): number {
    let amount = 0;
    for (let i = 0; i < products.length; i++) {
      amount += products[i].numOfCopies;
    }
    return amount;
  }

  isIphone(): boolean {
    return /iPhone/.test(navigator.userAgent);
  }

  explainHowToChaingeSettings() {
    const text = this.isPendingOrder ? 'order-summary.can-not-edit-settings' : 'order-summary.how-to-edit-settings';
    const duration = this.isPendingOrder ? 5000 : 2500;
    this.snackBar.open(this.translate.instant(text), '', {
      duration: duration,
      verticalPosition: 'top',
      panelClass: 'zx-top-snackbar'
    });
  }

  copyOrderLink(): void {
    const text = this.translate.instant('order-summary.copy-link.text');
    const orderId = this.orderID;
    const service = this.printingService[0];
    const link = `https://print.eazix.io/x/${service}/${orderId}`
    const orderNumber = this.orderID.slice(0, 8);
    const branchName = this.translate.instant('choose-branch.naming.' + this.printingService + '.' + this.branchName);
    const finalText = text + " " + orderNumber + " (" + branchName + "): " + link;
    navigator.clipboard.writeText(finalText).then(() => {
      this.translate.get('order-summary.copy-link.success').subscribe((res: string) => {
        this.snackBar.open(res, '', {
          duration: 1200,
          panelClass: ['auto-width', 'center-text'].filter(Boolean),
          verticalPosition: 'top',
        });
      });
    }).catch(err => {
      console.error('Could not copy text: ', err);
    });
  }

  // ====================================
}
